import { createContext, FC, PropsWithChildren, ReactNode, RefObject, useCallback, useContext, useRef } from 'react';
import { SwiperSlide } from 'swiper/react';
import cls from 'classnames';
import { useViewObserver } from '@lemon8/web-app-shared/util';
import { EPageModule } from '~/utils/page-module';

import './style.scss';

interface HomepageSlideProps extends PropsWithChildren {
  pageModule: EPageModule;
  className?: string;
  additionalContent?: ReactNode;
}

const ContentRefCtx = createContext<RefObject<HTMLDivElement>>({ current: null });

export const HomepageSlide: FC<HomepageSlideProps> = (props) => {
  const { children, className, additionalContent, pageModule } = props;
  const ref = useRef<HTMLDivElement>(null);

  const observedRef = useViewObserver({
    onView: useCallback(() => {
      window.Tea('wap_module_show', {
        current_page_module: pageModule,
      });
    }, []),
  });

  return (
    <SwiperSlide className={cls('homepage-slide', className)}>
      <div className="flex-wrapper" ref={observedRef}>
        <div className="content" ref={ref}>
          <ContentRefCtx.Provider value={ref}>{children}</ContentRefCtx.Provider>
        </div>
        {Boolean(additionalContent) && additionalContent}
      </div>
    </SwiperSlide>
  );
};

export const useContentRef = (): RefObject<HTMLDivElement> => {
  return useContext(ContentRefCtx);
};
